import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Link } from 'react-router';
import { SliderHelpers } from '../../../../../../../helpers';

class ModuleVideoSlider extends Component {

    render() {

        const { modules, numOfModules, params, courseName } = this.props,
            settings = SliderHelpers.getResponsiveSliderSettings();
        return (
            <section className="row course-module-slider">
                <div className="col-xs-12 module-slider">
                    <h4 className="h4 brand-color">Other modules of <strong>{ courseName }</strong></h4>
                    <Slider {...settings}>
                        { numOfModules.map((module, index) => {
                            return (
                                <div className="item-slide background-image" key={ index }>
                                    <div className="text-box color-mask">
                                        <h6 className="h6 item-title">{ modules[module].name }</h6>
                                        <ul className="buttons-left pos-bottom">
                                            <li>
                                                <Link className="btn btn-primary btn-block"
                                                      to={ `/training/courses/${ params.courseId }/modules/${ modules[module].id }` }>
                                                    <span className="label">View Module</span>
                                                    <span className="icon"><i className="fa fa-angle-right animated-right"/></span>
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            );
                        }) }
                    </Slider>
                </div>
            </section>
        );

    }

}

ModuleVideoSlider.propTypes = {
    numOfModules: PropTypes.array.isRequired,
    params: PropTypes.object.isRequired,
};

export default ModuleVideoSlider;


// WEBPACK FOOTER //
// src/client/components/site/features/training/courses/pages/elements/ModuleVideoSlider.js